
import { number } from "echarts";
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    totalNum: number,
  },
})
export default class Paging extends Vue {
  totalNum!: number; //总数
  public record = 16; //记录条数
  public currentPage1 = 1; //当前页
  public onPaging() {
    this.$emit("onPaging", this.record, this.currentPage1);
  }
}
